// eslint-disable-next-line
const reducer = (state: any, action: { type: any }) => {
  switch (action.type) {
    case 'doNothing':
      return {
        ...state,
      }

    default:
      return state
  }
}

export { reducer }
